import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../api/quarkusApi';

export function useFinancialDashboardResource(
  path,
  { selectedDate, viewByYear, viewAllPeriod },
  initialData = null,
) {
  const navigate = useNavigate();

  const [data, setData] = useState(initialData);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(() => {
    setLoading(true);
    const params = {
      selectedDate: selectedDate.format('YYYY/MM'),
      viewByYear,
      viewAllPeriod,
    };
    quarkusApi
      .get(path, { headers: { Authorization: sessionStorage.getItem('token') }, params })
      .then((returnFromApi) => setData(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [path, selectedDate, viewByYear, viewAllPeriod, navigate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading, error, refetch: fetchData };
}
